import { useState, useEffect, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Form, Col } from 'react-bootstrap';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import '../../pages/Searchs/styles.css';
import If from '../../components/If';
import Loading from '../../components/Loading';
import Button from '../../components/Button';
import EditButton from '../../components/EditButton';
import SearchEmpty from '../../components/SearchEmpty';
import Select from 'react-select';
import { CulturaResult, MaterialResult, RegistroFitossanitarioResult, RegistroFitossanitarioForm } from '../../models/modelsRegistrosFitossanitarios';
import { STRINGS_REGISTROSFITOSSANITARIOS } from '../../util/registrosFitossanitarios/string';
import { PaisResult } from '../../models/modelsPaises';
import api from '../../services/api';
import { _generateDate } from '../../util/convert';
import LoadingInForm from '../../components/LoadingInForm';

export default function RegistroFitossanitario() {
	const history = useHistory();
	const [registrosFitossanitarios, setRegistrosFitossanitarios] = useState<RegistroFitossanitarioResult[]>([]);
	const [errorSearch, setErrorSearch] = useState<any>(null);
	const [errorGetDestinatarios, setErrorGetRegistrosFitossanitarios] = useState<any>(null);
	const [emptySearch, setEmptySearch] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);
	const [loadingSearch, setLoadingSearch] = useState<boolean>(false);
	const [culturas, setCulturas] = useState<CulturaResult[]>([]);
	const [materiais, setMateriais] = useState<CulturaResult[]>([]);
	const [paisOrigem, setPaisOrigem] = useState<PaisResult[]>([]);
	const [paisDestino, setPaisDestino] = useState<PaisResult[]>([]);

	const initialValues: RegistroFitossanitarioForm = {
		culturaId: '',
		materialId: '',
		paisOrigemId: '',
		paisDestinoId: '',
		finalidade: '',
		restricao: '',
		organismos: '',
		formaCertificacao: ''
	}

	const { register, errors, handleSubmit, getValues, control, formState: { isDirty } } = useForm({
		defaultValues: initialValues,
		mode: 'onTouched',
		//resolver: yupResolver(registroFitossanitarioSchema)
	})

	const getRegistrosFitossanitarios = async () => {
		try {
			setErrorGetRegistrosFitossanitarios(null);

			const { data, status } = await api.get<RegistroFitossanitarioResult[]>('api/v1/registros-fitossanitarios/RegistrosFitossanitarios/obtertodos');

			if (status === 200) {
				setRegistrosFitossanitarios(data);
			}
		} catch (error: any) {
			setErrorGetRegistrosFitossanitarios(error?.response?.data);
		}
	}

	const getData = async () => {
		setLoading(true);

		try {
			const culturasCarga = await api.get<CulturaResult[]>(`api/v1/Shipment/cultura_obter_ativos`);
			const materiaisCarga = await api.get<CulturaResult[]>(`api/v1/Shipment/material_obter_ativos`);
			const paisesCarga = await api.get<PaisResult[]>(`api/v1/Paises/`);

			if (culturasCarga.status === 200)
				setCulturas(culturasCarga.data);

			if (materiaisCarga.status === 200)
				setMateriais(materiaisCarga.data);

			if (paisesCarga.status === 200) {
				setPaisOrigem(paisesCarga.data);
				setPaisDestino(paisesCarga.data);
			}

		}
		catch (error: any) {
		}

		setLoading(false);
	}

	useEffect(() => {
		getData();
		getRegistrosFitossanitarios();
	}, []);

	const search = async (queries?: any) => {
		let finalidade = getValues('finalidade');
		let restricao = getValues('restricao');
		let organismos = getValues('organismos');
		let formaCertificacao = getValues('formaCertificacao');

		let cultura = queries?.cultureId !== "" ? parseInt(queries?.cultureId) : 0;
		let material = queries?.materialId !== "" ? parseInt(queries?.materialId) : 0;
		let paisOrigem = queries?.paisOrigemId !== "" ? queries?.paisOrigemId.value : 0;
		let paisDestino = queries?.paisDestinoId !== "" ? queries?.paisDestinoId.value : 0;

		setLoadingSearch(true);
		setErrorSearch(null);

		try {	
			const { data } = await api.get<RegistroFitossanitarioResult[]>(`api/v1/registros-fitossanitarios/RegistrosFitossanitarios/obterporfiltro?
			finalidade=${finalidade}&restricao=${restricao}&organismos=${organismos}&formaCertificacao=${formaCertificacao}
			&culturaId=${cultura}&materialId=${material}&paisOrigemId=${paisOrigem}&paisDestinoId=${paisDestino}`);

			if (data.length) {
				setRegistrosFitossanitarios(data);
				setEmptySearch(false);
			} else {
				setEmptySearch(true);
			}

		} catch (error: any) {
			setErrorSearch(error?.response?.data);
		}
		setLoadingSearch(false);
	}

	const actions = ({ data }: any) => (
		<Fragment>
			<EditButton
				onClick={() => history.push({
					pathname: '/registrosfitossanitarios/editar/',
					state: {
						id: data.id
					}
				})}
			/>
		</Fragment>
	)

	return <div className="container-custom-search">
		<div className="top-content">
			<h3>{STRINGS_REGISTROSFITOSSANITARIOS.SEARCH_REGISTROS_FITOSSANITARIOS}</h3>
		</div>
		<div className="row-buttons">
			<Button
				onClick={() => history.push('/registrosfitossanitarios/cadastrar/')}
				contained
				title="Adicionar"
				type="button"
			/>
		</div>
		<br />
		<Form onSubmit={handleSubmit(search)}>
			<Form.Row className="row-custom">
				<Form.Group as={Col} md={3}>
					<Form.Label>
						Cultura
						&nbsp;&nbsp;
						<If condition={loading}>
							<LoadingInForm />
						</If>
					</Form.Label>
					<Form.Control
						as="select"
						ref={register}
						name="cultureId"
					>
						<Form.Control
							as="option"
							label="Escolha uma cultura"
						/>
						{culturas.map(culture =>
							<Form.Control
								key={culture.id}
								as="option"
								label={culture.nome}
								value={culture.id}
							/>
						)}
					</Form.Control>
				</Form.Group>
				<Form.Group as={Col} md={3}>
					<Form.Label>
						Material
						&nbsp;&nbsp;
						<If condition={loading}>
							<LoadingInForm />
						</If>
					</Form.Label>
					<Form.Control
						as="select"
						ref={register}
						name="materialId"
					>
						<Form.Control
							as="option"
							label="Escolha um material"
						/>
						{materiais.map(material =>
							<Form.Control
								key={material.id}
								as="option"
								label={material.nome}
								value={material.id}
							/>
						)}
					</Form.Control>
				</Form.Group>	
				<Form.Group as={Col} md={3}>
					<Form.Label>
						País de Origem
						&nbsp;&nbsp;
						<If condition={loading}>
							<LoadingInForm />
						</If>
					</Form.Label>
					<Controller
						control={control}
						name="paisOrigemId"
						isInvalid={errors.paisOrigemId !== undefined}
						as={<Select
							placeholder="Selecione um país de origem"
							options={paisOrigem.map(local => Object.assign({ value: local.id, label: local.nomePTBR }))}
							isClearable
						/>}
					/>
					<If condition={errors.paisOrigemId}>
						<p className="error-field">{errors.paisOrigemId?.message}</p>
					</If>
				</Form.Group>
				<Form.Group as={Col} md={3}>
					<Form.Label>
						País de Destino
						&nbsp;&nbsp;
						<If condition={loading}>
							<LoadingInForm />
						</If>
					</Form.Label>
					<Controller
						control={control}
						name="paisDestinoId"
						isInvalid={errors.paisDestinoId !== undefined}
						as={<Select
							placeholder="Selecione um país de destino"
							options={paisDestino.map(local => Object.assign({ value: local.id, label: local.nomePTBR }))}
							isClearable
						/>}
					/>
					<If condition={errors.paisDestinoId}>
						<p className="error-field">{errors.paisDestinoId?.message}</p>
					</If>
				</Form.Group>
			</Form.Row>
			<Form.Row className="row-custom">
				<Form.Group as={Col} md={3}>
					<Form.Label>Finalidade</Form.Label>
					<Form.Control
						ref={register}
						name="finalidade"
						maxLength={15}
						autoComplete="off"
					/>
				</Form.Group>
				<Form.Group as={Col} md={3}>
					<Form.Label>Restrição</Form.Label>
					<Form.Control
						ref={register}
						name="restricao"
						maxLength={15}
						autoComplete="off"
					/>
				</Form.Group>
				<Form.Group as={Col} md={3}>
					<Form.Label>Organismos</Form.Label>
					<Form.Control
						ref={register}
						name="organismos"
						maxLength={15}
						autoComplete="off"
					/>
				</Form.Group>
				<Form.Group as={Col} md={3}>
					<Form.Label>Forma de Certificação</Form.Label>
					<Form.Control
						ref={register}
						name="formaCertificacao"
						maxLength={15}
						autoComplete="off"
					/>
				</Form.Group>
				<span className="filter-btn">
					<Button
						title="Buscar"
						type="submit"
						contained
						isLoading={loadingSearch}
					/>
				</span>
			</Form.Row>
		</Form>
		<If condition={!loading && !emptySearch && registrosFitossanitarios.length}>
			<div className="search-content">
				<div className="ag-theme-alpine" style={{ height: '70vh', width: '100%' }}>
					<AgGridReact
						rowData={registrosFitossanitarios}
						defaultColDef={{ flex: 1, sortable: true, resizable: true }}
						pagination
						paginationPageSize={10}
						frameworkComponents={{
							actions: actions,
						}}
					>
						<AgGridColumn
							headerName='Cultura'
							field="culturaNome"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName='Material'
							field="materialNome"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName='País de Origem'
							field="paisOrigemNome"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName='País de Destino'
							field="paisDestinoNome"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName='Finalidade'
							field="finalidade"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName='Restrição'
							field="restricao"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName='Organismos'
							field="organismos"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							headerName='Forma de Certificação'
							field="formaCertificacao"
							cellStyle={{
								justifyContent: 'left'
							}}
							sort="asc"
						/>
						<AgGridColumn
							field='Ações'
							cellRenderer='actions'
							maxWidth={130}
						/>
					</AgGridReact>
				</div>
			</div>
		</If>
		<If condition={loading}>
			<div className="loading-container">
				<Loading />
			</div>
		</If>
		<If condition={emptySearch}>
			<div className="div-empty">
				<SearchEmpty />
			</div>
		</If>
	</div>;
}